<template src="./index.html" />
<script>
import { mapState } from 'vuex';
import { validationMixin } from 'vuelidate';
import {
  required, email,
} from 'vuelidate/lib/validators';
import API from '@/services/GraphQl';
import cognitoGroups from '@/constants/cognitoGroups';
import ConverEmailToLowerCase from '@/mixins/ConverEmailToLowerCase';
export default {
  name: 'UserInvitationModal',
  mixins: [validationMixin, ConverEmailToLowerCase],
  data: () => ({
    dialog: false,
    error: null,
    pageObjName: 'form',
    form: {
      name: '',
      email: '',
      isPremium: false,
    },
    selectedGroup: '',
    groups: [
      {
        title: 'Free',
        value: 'free',
      },
      {
        title: 'Collaborator',
        value: cognitoGroups.COLLABORATOR,
      },
      {
        title: 'Pro',
        value: cognitoGroups.PRO,
      },
    ],
  }),
  validations: {
    form: {
      email: {
        required, email,
      },
      name: {
        required,
      },
    },
  },
  computed: {
    ...mapState(['showInviteUserModal', 'users']),
    emailErrors() {
      const errors = [];
      if (!this.$v.form.email.$dirty) return errors;
      if (!this.$v.form.email.email) {
        errors.push('Must be valid e-mail');
      }
      if (!this.$v.form.email.required) {
        errors.push('Please enter required value');
      }
      if (this.error) {
        errors.push(this.error);
      }
      return errors;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.form.name.$dirty) return errors;
      if (!this.$v.form.name.required) {
        errors.push('Please enter required value');
      }
      return errors;
    },
  },
  watch: {
    dialog() {
      if (!this.dialog) {
        this.clearCreateForm();
      }
      this.$nextTick(() => {
        this.selectedGroup = 'free';
      });
    },
    showInviteUserModal() {
      this.dialog = true;
    },
  },
  methods: {
    async createInvitation() {
      this.$v.form.$touch();
      if (!this.$v.form.$invalid && !this.error) {
        this.$store.commit('spinner', true);
        try {
          const { data } = await API.createUser({
            ...this.form,
            isPremium: this.selectedGroup === cognitoGroups.PRO,
            isDesignPartner: this.selectedGroup === cognitoGroups.COLLABORATOR,
          });
          const newUsersArr = [].concat(this.users, data.response);
          const addToList = (this.$route.params.mode === cognitoGroups.COLLABORATOR
              && [cognitoGroups.COLLABORATOR, cognitoGroups.PRO].includes(this.selectedGroup))
            || this.$route.params.mode === 'all';
          if (addToList) {
            this.$store.commit('changeUserList', newUsersArr);
          }
          this.dialog = false;
        } catch (err) {
          console.log('create user err', err);
          this.error = err.errors[0].message;
        } finally {
          this.$store.commit('spinner', false);
        }
      }
    },
    clearCreateForm() {
      this.$refs.invitationForm.reset();
      this.$v.form.$reset();
    },
  },
};
</script>
<style scoped lang="scss" src="./index.scss"></style>
